import { handleActions, combineActions } from 'redux-actions';
import { deepFreeze } from '@mw/helpers';

import { DisabledChatbotStory, EventTypes, FormNames } from '~/constants';
import { DEFAULT_MESSAGES } from '~/containers/forms/KeywordEvent/constants';

import {
  resetTGChannelDraft,
  setTGChannelDraft,
  setSMSChannelDraft,
  resetSMSChannelDraft,
  setWAChannelDraft,
  resetWAChannelDraft,
  setVIChannelDraft,
  resetVIChannelDraft,
  setRCSChannelDraft,
  resetRCSChannelDraft,
  setWeChatChannelDraft,
  resetWeChatChannelDraft,
  setCurrentChannel,
} from '~/actions/forms';

const initialState = deepFreeze({
  [FormNames.CREATE_TG_CHANNEL]: {
    drafts: {
      name: 'chats-test-telegram',
      chatbot_story_id: DisabledChatbotStory.KEY,
      opt_out_message: DEFAULT_MESSAGES[EventTypes.OPT_OUT],
      help_message: DEFAULT_MESSAGES[EventTypes.HELP],
      welcome_message: DEFAULT_MESSAGES[EventTypes.WELCOME],
      access_token: '',
    },
  },
  [FormNames.CREATE_SMS_CHANNEL]: {
    drafts: {
      name: 'chats-test-sms',
      region: 'EU',
      country: { code: 'UA', country: 'Ukraine', phoneCode: '380' },
      chatbot_story_id: DisabledChatbotStory.KEY,
      vln_quantity: 1,
      opt_out_message: DEFAULT_MESSAGES[EventTypes.OPT_OUT],
      help_message: DEFAULT_MESSAGES[EventTypes.HELP],
    },
  },
  [FormNames.CREATE_WA_CHANNEL]: {
    drafts: {
      name: 'chats-test-whatsapp',
      chatbot_story_id: DisabledChatbotStory.KEY,
      opt_out_message: DEFAULT_MESSAGES[EventTypes.OPT_OUT],
      help_message: DEFAULT_MESSAGES[EventTypes.HELP],
      welcome_message: DEFAULT_MESSAGES[EventTypes.WELCOME],
    },
  },
  [FormNames.CREATE_VI_CHANNEL]: {
    drafts: {
      name: 'chats-test-viber',
      chatbot_story_id: DisabledChatbotStory.KEY,
      opt_out_message: DEFAULT_MESSAGES[EventTypes.OPT_OUT],
      help_message: DEFAULT_MESSAGES[EventTypes.HELP],
      welcome_message: DEFAULT_MESSAGES[EventTypes.WELCOME],
    },
  },
  [FormNames.CREATE_RCS_CHANNEL]: {
    drafts: {
      name: '',
      chatbot_story_id: DisabledChatbotStory.KEY,
      region: '',
      description: '',
      country: [],
      category: '',
      email: '',
      phone: '',
      banner: '',
      color: '',
      logo: '',
      privacy: '',
      terms: '',
      website: '',
      opt_out_message: DEFAULT_MESSAGES[EventTypes.OPT_OUT],
      help_message: DEFAULT_MESSAGES[EventTypes.HELP],
      welcome_message: DEFAULT_MESSAGES[EventTypes.WELCOME],
    },
  },
  [FormNames.CREATE_WECHAT_CHANNEL]: {
    drafts: {
      name: 'chats-test-wechat',
      chatbot_story_id: DisabledChatbotStory.KEY,
      opt_out_message: DEFAULT_MESSAGES[EventTypes.OPT_OUT],
      help_message: DEFAULT_MESSAGES[EventTypes.HELP],
      welcome_message: DEFAULT_MESSAGES[EventTypes.WELCOME],
    },
  },
  currentChannel: null,
});

export default handleActions(
  {
    [combineActions(
      setTGChannelDraft,
      setSMSChannelDraft,
      setWAChannelDraft,
      setVIChannelDraft,
      setRCSChannelDraft,
      setWeChatChannelDraft
    )]: (state, { payload }) => {
      const { formName, ...fields } = payload;

      return {
        ...state,
        [formName]: {
          ...state[formName],
          drafts: { ...state[formName].drafts, ...fields },
        },
      };
    },
    [combineActions(
      resetTGChannelDraft,
      resetSMSChannelDraft,
      resetWAChannelDraft,
      resetVIChannelDraft,
      resetRCSChannelDraft,
      resetWeChatChannelDraft
    )]: (state, { payload: { formName, draftFields } }) => {
      if (!Array.isArray(draftFields)) {
        return {
          ...state,
          [formName]: initialState[formName],
        };
      }

      const newForm = { ...state[formName] };

      draftFields.forEach((field) => {
        newForm.drafts[field] = initialState[formName].drafts[field];
      });

      return {
        ...state,
        [formName]: newForm,
      };
    },
    [setCurrentChannel]: (state, { payload: currentChannel }) => ({
      ...state,
      currentChannel,
    }),
  },
  initialState
);
